import React from 'react';
import { HeroSection } from '../components/landing/HeroSection';
import { PainSection } from '../components/landing/PainSection';
import { TruthSection } from '../components/landing/TruthSection';
import { WhyFailSection } from '../components/landing/WhyFailSection';
import { MechanismSection } from '../components/landing/MechanismSection';
import { BenefitsSection } from '../components/landing/BenefitsSection';
import { TargetSection } from '../components/landing/TargetSection';
import { PricingSection } from '../components/landing/PricingSection';
export function LandingPage() {
  return <main className="min-h-screen bg-[#0a0a0a] text-white selection:bg-blue-600 selection:text-white font-sans" data-id="element-154">
      <HeroSection data-id="element-155" />
      <PainSection data-id="element-156" />
      <TruthSection data-id="element-157" />
      <WhyFailSection data-id="element-158" />
      <MechanismSection data-id="element-159" />
      <BenefitsSection data-id="element-160" />
      <TargetSection data-id="element-161" />
      <PricingSection data-id="element-162" />

      <footer className="py-12 text-center text-gray-600 text-sm border-t border-white/5 bg-[#0a0a0a]" data-id="element-163">
        <p data-id="element-164">
          © {new Date().getFullYear()} LOCK IN System. Todos los derechos
          reservados.
        </p>
      </footer>
    </main>;
}